// import React, { useState } from 'react';
// import './PopularDestinations.css';

// const PopularDestinations = () => {
//   const [showItinerary, setShowItinerary] = useState(false);

//   const destinations = [
//     { id: 1, name: 'Chopta Tungnath', image: 'https://assets.telegraphindia.com/telegraph/2022/Dec/1672129934_photo6.jpg', discount: null },
//     { id: 2, name: 'Jibhi Tirthan valley', image: 'https://i0.wp.com/www.crossroadadventure.com/wp-content/uploads/2018/12/Save-5-.jpeg?zoom=3&resize=850%2C478&ssl=1', discount: null },
//     { id: 3, name: 'Mcleodganj Triund', image: 'https://mediaim.expedia.com/destination/1/c9040b24c15b5bc39668ab557c8e1bb5.jpg?impolicy=fcrop&w=1040&h=580&q=mediumHigh', discount: null },
//     { id: 4, name: 'Hampta Pass trek', image: 'https://www.bontravelindia.com/wp-content/uploads/2022/05/Hampta-Pass-Himachal.jpg', discount: null },
//     { id: 5, name: 'Manali Kasol', image: 'https://tse2.mm.bing.net/th/id/OIP.J0VhDej1aGn2td8mEVQPPgHaEK?rs=1&pid=ImgDetMain&o=7&rm=3', discount: null },
//     { id: 6, name: 'Chakrata Tiger falls', image: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/07/58/d9/f3/tiger-falls.jpg?w=1200&h=1200&s=1', discount: null },
//     { id: 7, name: 'Shangarh,sainj valley', image: 'https://i.pinimg.com/1200x/5f/e4/5d/5fe45de5fbb6e4b7abd8bf46bbdd0739.jpg', discount: null },
//     { id: 8, name: 'Varanasi Ghats', image: 'https://i.pinimg.com/736x/fd/aa/75/fdaa75f0854b00753f0bd8a722676836.jpg', discount: null },
//     { id: 9, name: 'Udaipur', image: 'https://i.pinimg.com/736x/9c/4f/2c/9c4f2c33ff9079e7abafca99a53668ae.jpg', discount: null },
//     { id: 10, name: 'Jaisalmer', image: 'https://i.pinimg.com/736x/9c/11/0d/9c110df5b0f5cf04bb9a597f81e67771.jpg', discount: null },
//     { id: 11, name: 'Kedarnath', image: 'https://i.pinimg.com/736x/e1/98/9f/e1989f4fc766b63dbb10f1244f253480.jpg', discount: null },
//     { id: 12, name: 'Kedarkantha trek', image: 'https://i.pinimg.com/1200x/09/43/12/0943121d4b2e5fbe2255f72123f723ff.jpg', discount: null }
//   ];

//   const handleCardClick = (destinationName) => {
//     if (destinationName === 'Taj Mahal') {
//       setShowItinerary(true);
//     }
//   };

//   const handleRegister = () => {
//     const formSection = document.getElementById('form');
//     if (formSection) {
//       formSection.scrollIntoView({ behavior: 'smooth' });
//     }
//     setShowItinerary(false);
//   };

//   return (
//     <section className="section popular-destinations" id="our-packages"> {/* Added id */}
//       <div className="container">
//         <div className="section-title">
//           <h2 className="section-heading">Popular Destinations</h2>
//         </div>
        
//         <div className="destinations-grid">
//           {destinations.map((destination) => (
//             <div key={destination.id} className="destination-card" onClick={() => handleCardClick(destination.name)}>
//               <div className="destination-image">
//                 <img src={destination.image} alt={destination.name} />
//                 {destination.discount && (
//                   <div className="discount-badge">
//                     {destination.discount}
//                   </div>
//                 )}
//               </div>
//               <div className="destination-info">
//                 <h3>{destination.name}</h3>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {showItinerary && (
//         <div className="itinerary-overlay" onClick={() => setShowItinerary(false)}>
//           <div className="itinerary-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="itinerary-header">
//               <h3>Jaisalmer Getaway – 3 Nights / 4 Days</h3>
//               <button className="itinerary-close" onClick={() => setShowItinerary(false)}>&times;</button>
//             </div>
//             <div className="itinerary-body">
//               <div className="itinerary-day">
//                 <h4>Day 0 • Departure</h4>
//                 <ul>
//                   <li>Assemble at IFFCO Chowk Metro Station, Gurugram – 6:30 PM</li>
//                   <li>Overnight journey to Jaisalmer</li>
//                 </ul>
//               </div>
//               <div className="itinerary-day">
//                 <h4>Day 1 • Desert Camping & Jeep Safari</h4>
//                 <ul>
//                   <li>Arrive by afternoon, check in at Sam Dunes desert camp, lunch</li>
//                   <li>Jeep safari to golden dunes and sunset viewpoints</li>
//                   <li>Traditional Rajasthani welcome, snacks & tea</li>
//                   <li>Bonfire, folk dance, DJ night, buffet dinner</li>
//                 </ul>
//               </div>
//               <div className="itinerary-day">
//                 <h4>Day 2 • Camel Safari, Tanot & Longewala</h4>
//                 <ul>
//                   <li>Sunrise camel safari; breakfast at camp</li>
//                   <li>Visit Tanot Mata Temple and Longewala War Post</li>
//                   <li>Explore Kuldhara Village and Bada Bagh (lunch en route)</li>
//                   <li>Evening snacks & bonfire under starry Thar sky; buffet dinner</li>
//                 </ul>
//               </div>
//               <div className="itinerary-day">
//                 <h4>Day 3 • Jaisalmer City & Return</h4>
//                 <ul>
//                   <li>Check-out; visit Jaisalmer Fort, Patwaon Ki Haveli, Gadisar Lake</li>
//                   <li>Lunch and local shopping</li>
//                   <li>Assemble 4:00 PM at Gadisar Lake parking; depart for Gurugram</li>
//                   <li>Overnight journey; reach next morning with wonderful memories</li>
//                 </ul>
//               </div>
//             </div>
//             <div className="itinerary-actions">
//               <button className="btn btn-outline" onClick={() => setShowItinerary(false)}>Close</button>
//               <button className="btn btn-primary" onClick={handleRegister}>Register Now</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default PopularDestinations;




import React, { useState } from 'react';
import './PopularDestinations.css';

const PopularDestinations = () => {

  const destinations = [
    { 
      id: 1, 
      name: 'Chopta Tungnath', 
      image: 'https://assets.telegraphindia.com/telegraph/2022/Dec/1672129934_photo6.jpg',
      pdf: 'https://drive.google.com/file/d/162GPEB94GL5-0-1MMB3K2SJAuxFRAEcI/view?usp=sharing', 
      discount: null 
    },
    { 
      id: 2, 
      name: 'Jibhi Tirthan valley', 
      image: 'https://i0.wp.com/www.crossroadadventure.com/wp-content/uploads/2018/12/Save-5-.jpeg?zoom=3&resize=850%2C478&ssl=1',
      pdf: 'https://drive.google.com/file/d/1LesbTuEdsQj8ck62YkbKrUhHCoEKWK_d/view?usp=sharing',
      discount: null 
    },
    { 
      id: 3, 
      name: 'Mcleodganj Triund', 
      image: 'https://mediaim.expedia.com/destination/1/c9040b24c15b5bc39668ab557c8e1bb5.jpg?impolicy=fcrop&w=1040&h=580&q=mediumHigh',
      pdf: 'https://drive.google.com/file/d/1Vy0LYs7N3LhiWQ6ptMTSMYFVs2BODl1n/view?usp=sharing',
      discount: null 
    },

    // Add PDF link for each destination
    { id: 4, name: 'Manali Kasol', image: 'https://i.pinimg.com/736x/2b/82/52/2b825215af94260b10cd6102513fb00a.jpg', pdf: 'https://drive.google.com/file/d/1Ef_ikZIrcpBtQAJMfvyhsCln-I2Xt3CY/view?usp=sharing', discount: null },
    { id: 5, name: 'Udaipur', image: 'https://i.pinimg.com/736x/9c/4f/2c/9c4f2c33ff9079e7abafca99a53668ae.jpg', pdf: 'https://drive.google.com/file/d/1FPu7rymCtsCjXtWXn6n1flvAIHsQvUMX/view?usp=sharing', discount: null },
    { id: 6, name: 'Chakrata Tiger falls', image: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/07/58/d9/f3/tiger-falls.jpg?w=1200&h=1200&s=1', pdf: 'https://drive.google.com/file/d/1w6qffAcPXCgMdNN28xDmuHMY6kolvxkS/view?usp=sharing', discount: null },
    { id: 7, name: 'Jaisalmer', image: 'https://i.pinimg.com/736x/9c/11/0d/9c110df5b0f5cf04bb9a597f81e67771.jpg', pdf: 'https://drive.google.com/file/d/1Sq3ag9zo6o5tUme4NecVEzF_zIxQWmod/view?usp=sharing', discount: null },
    { id: 8, name: 'Kedarnath', image: 'https://i.pinimg.com/736x/e1/98/9f/e1989f4fc766b63dbb10f1244f253480.jpg', pdf: 'https://drive.google.com/file/d/1fxFHbS0fNpRtNbsbxkSvo9q4qg6WhaPz/view?usp=sharing', discount: null },
    { id: 9, name: 'Kedarkantha trek', image: 'https://i.pinimg.com/1200x/09/43/12/0943121d4b2e5fbe2255f72123f723ff.jpg', pdf: 'https://drive.google.com/file/d/1u1iw_Gc6k8vNgPIoYblVUsGO5qXhKrJ8/view?usp=sharing', discount: null },
    { id: 10, name: 'Chitkul Sangla Kalpa', image: 'https://i.pinimg.com/1200x/f1/23/d9/f123d964fb8d7e4882d5579375904bf8.jpg', pdf: 'https://drive.google.com/file/d/1PMx8xSOv6dZx7_Eq-gykPLIAhoy_NK7E/view?usp=sharing', discount: null },
    { id: 11, name: 'Auli', image: 'https://i.pinimg.com/736x/a3/b9/a8/a3b9a8f5d8471d28086a700325c1a31e.jpg', pdf: 'https://drive.google.com/file/d/18f9CA2pzHBVIB5qYIpvcPNI6-TWtpbCY/view?usp=sharing', discount: null },
    { id: 12, name: 'Madhmaheshwar', image: 'https://i.pinimg.com/736x/30/fc/77/30fc7706bafca70c3a060e6eb486f176.jpg', pdf: 'https://drive.google.com/file/d/13pMWAVhBIwDkRBezRfWghraOjExefXJJ/view?usp=sharing', discount: null },
    { id: 13, name: 'Kasol Kheerganga', image: 'https://i.pinimg.com/736x/d8/17/c5/d817c59905606bc2e4c8a751133b7ad2.jpg', pdf: 'https://drive.google.com/file/d/1kf45EhzHppHWAJ7CApumrdC2t0JcG3YN/view?usp=sharing', discount: null },
    { id: 14, name: 'Harshil Valley', image: 'https://i.pinimg.com/736x/a8/ae/68/a8ae68fdcda950bd4406abfbecc2400b.jpg', pdf: 'https://drive.google.com/file/d/1kL4u_K2_q__VyKRZAIfVy3x9CeY245I1/view?usp=sharing', discount: null },
    { id: 15, name: 'Yulla Kanda', image: 'https://i.pinimg.com/1200x/ab/d8/69/abd869d8a7f91c20e356c1b013202b60.jpg', pdf: 'https://drive.google.com/file/d/19w-UJ0k2ylxs9nmilJbW6CtK8IFOO2ES/view?usp=sharing', discount: null },
    { id: 16, name: 'Sangla Valley', image: 'https://i.pinimg.com/1200x/e5/17/0e/e5170e14d01ca9346636d96eaadeb637.jpg', pdf: 'https://drive.google.com/file/d/1NCIzm8lntUCKAKnktlZqTCW264d2vGhN/view?usp=sharing', discount: null },
    { id: 17, name: 'Pushkar 2N/3D', image: 'https://i.pinimg.com/736x/6a/87/34/6a8734c81cd0fa8621714fe9eb1e745c.jpg', pdf: 'https://drive.google.com/file/d/111h--3hXl0Ofgtz7RV8oGbA1Yf0X1oAr/view?usp=sharing', discount: null },
    { id: 18, name: 'Auli Chopta', image: 'https://i.pinimg.com/1200x/1c/ba/14/1cba141bf72d2fcac3e15213958a1dc4.jpg', pdf: 'https://drive.google.com/file/d/1N5PjIRDAwA_pWg41ViQux_HT9lHjNcNi/view?usp=sharing', discount: null },
    { id: 19, name: 'Mcleodganj Bir', image: 'https://i.pinimg.com/736x/a8/2f/67/a82f6733bca71cae0535d060d989e312.jpg', pdf: 'https://drive.google.com/file/d/13-wFvIR9flDDt6QyHxyiduIXquuTciIm/view?usp=sharing', discount: null },
    { id: 20, name: 'Ujjain', image: 'https://i.pinimg.com/736x/73/d9/49/73d949e392231c4921a064826cb828c9.jpg', pdf: 'https://drive.google.com/file/d/1-1H7kag08rT-Xi4qWVGPxynN04SZYpPS/view?usp=sharing', discount: null },
    { id: 21, name: 'Pushkar 1N/2D', image: 'https://i.pinimg.com/736x/f5/db/d0/f5dbd00b92ddc07b8617f9e4f613541c.jpg', pdf: 'https://drive.google.com/file/d/1fMvbUuYchEd_arDLk5XJwYU6riQVbqUF/view?usp=sharing', discount: null },
    { id: 22, name: 'Manali 2N/3D', image: 'https://i.pinimg.com/1200x/1c/ba/14/1cba141bf72d2fcac3e15213958a1dc4.jpg', pdf: 'https://drive.google.com/file/d/12SyBwbKBl2Zv4p-ggyxri6EVxiSpLNGV/view?usp=sharing', discount: null },
  ];

  const handleCardClick = (destination) => {
    if (destination.pdf) {
      window.open(destination.pdf, "_blank");  // Directly open PDF
    }
  };

  return (
    <section className="section popular-destinations" id="our-packages">
      <div className="container">
        <div className="section-title">
          <h2 className="section-heading">Popular Destinations</h2>
        </div>

        <div className="destinations-grid">
          {destinations.map((destination) => (
            <div 
              key={destination.id} 
              className="destination-card" 
              onClick={() => handleCardClick(destination)}
              style={{ cursor: 'pointer' }}
            >
              <div className="destination-image">
                <img src={destination.image} alt={destination.name} />
              </div>
              <div className="destination-info">
                <h3>{destination.name}</h3>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PopularDestinations;
